// extracted by mini-css-extract-plugin
export default {"table":"desktop-table_table__bB9-q","table_Row":"desktop-table_table_Row__mY+bw"};